export default __webpack_public_path__ + "static/media/slider_6.09c79963.jpg";